// extracted by mini-css-extract-plugin
export default {"wrap":"QH-z","fullWidth":"RH-z","hideOnDesktop":"SH-z","content":"TH-z","hasOpenedNav":"UH-z","crumbsList":"VH-z","dropdownsWrap":"WH-z"};